import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrossinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.933 8.5L15 13.567 13.567 15 8.5 9.933 3.433 15 2 13.567 7.067 8.5 2 3.433 3.433 2 8.5 7.067 13.567 2 15 3.433 9.933 8.5z",
		fill: "currentColor"
	})
});
export default SvgCrossinline;
